export const BIOMETRICS_NOT_AVAILABLE_MESSAGE: string =
  'biometrics.not_available';
